/**
 * music21j -- Javascript reimplementation of Core music21p features.
 * music21/bar -- Barline objects
 *
 * Copyright (c) 2013-24, Michael Scott Asato Cuthbert
 * Based on music21 (=music21p), Copyright (c) 2006-24, Michael Scott Asato Cuthbert
 *
 */
import * as base from './base';
import { Music21Exception } from './exceptions21';

const barTypeList = [
    'regular',
    // 'single', // Deprecated alias for 'regular',
    'dotted',
    'dashed',
    'heavy',
    'double',
    // 'end',  // Deprecated alias for 'final',
    'final',
    'heavy-light',
    'heavy-heavy',
    'tick',
    'short',
    'none',
];

// MusicXML Barline names
const barTypeDict = {
    'light-light': 'double',
    'light-heavy': 'final',
};

const reverseBarTypeDict = {
    'double': 'light-light',
    'final': 'light-heavy',
};

export class BarException extends Music21Exception {}

function typeToMusicXMLBarStyle(value: string): string {
    if (reverseBarTypeDict[value] !== undefined) {
        return reverseBarTypeDict[value];
    } else {
        return value;
    }
}

export function standardizeBarType(value: string='regular'): string {
    value = value.toLowerCase();
    if (value === 'end') {
        value = 'final';
    } else if (value === 'single') {
        value = 'regular';
    }

    if (barTypeList.includes(value)) {
        return value;
    }
    if (barTypeDict[value] !== undefined) {
        return barTypeDict[value];
    }
    throw new BarException(`cannot process style: ${value}`);
}

export class Barline extends base.Music21Object {
    _type: string;
    location: string;

    static get className() { return 'music21.bar.Barline'; }

    constructor(type='regular', location='right') {
        super();

        this.type = type;
        this.location = location; // left, right, middle, None
    }

    get type(): string {
        return this._type;
    }

    set type(v: string) {
        this._type = standardizeBarType(v);
    }

    musicXMLBarStyle(): string {
        return typeToMusicXMLBarStyle(this.type);
    }
}

export default Barline;
